import {
  LineOfBusiness,
  ReverseCoverageTypesCodes,
} from '../../common/Constants';

export type GuestLobOption = {
  key: string;
  displayName: string;
  description: string;
  dntIcon: string;
  displayOrder: number;
  dnt_name: string;
};

export type FilterGuestLobOptionsParams = {
  lobs?: GuestLobOption[];
  isGuestDeeplinkFlow?: boolean;
  coverageType?: string;
  lineOfBusiness?: string;
};

const CNS_LOB_KEYS = new Set([
  LineOfBusiness.CNS,
  'CNS',
  'CS',
  'C&S',
  'MEDICAID',
]);

const isBlankLineOfBusiness = (lineOfBusiness?: string) =>
  !lineOfBusiness?.trim();

const isCnsOrMedicaidLob = (lobKey?: string) =>
  CNS_LOB_KEYS.has((lobKey || '').trim().toUpperCase());

export const shouldFilterCnsForVisionGuestDeeplink = ({
  isGuestDeeplinkFlow,
  coverageType,
  lineOfBusiness,
}: Omit<FilterGuestLobOptionsParams, 'lobs'>) =>
  Boolean(
    isGuestDeeplinkFlow &&
      coverageType === ReverseCoverageTypesCodes.VISION &&
      isBlankLineOfBusiness(lineOfBusiness)
  );

export const getFilteredGuestLobOptions = ({
  lobs,
  isGuestDeeplinkFlow,
  coverageType,
  lineOfBusiness,
}: FilterGuestLobOptionsParams): GuestLobOption[] => {
  if (!lobs?.length) {
    return [];
  }

  if (
    !shouldFilterCnsForVisionGuestDeeplink({
      isGuestDeeplinkFlow,
      coverageType,
      lineOfBusiness,
    })
  ) {
    return lobs;
  }

  return lobs.filter((lob) => !isCnsOrMedicaidLob(lob?.key));
};
